import React, { useMemo } from "react";
import PrintDocumentsSelectionModal from "@/components/PrintDocuments/PrintDocumentsSelectionModal";

const DOCUMENT_NAMES = [
  "BOOKING CONFIRMATION FREIGHTED",
  "BOOKING CONFIRMATION NON - FREIGHTED",
  "BOOKING RATE QUOTE",
  "PRE ALERT AGENT",
  "TRUCKING INSTRUCTIONS",
  "DOCK RECEIPT",
  "DOCK RECEIPT TRUCKER",
  "HBL DRAFT PROOF COPY",
  "HBL ORIGINAL FREIGHTED",
  "HBL ORIGINAL NON - FREIGHTED",
  "HBL NON NEGO. FREIGHTED",
  "HBL NON NEGO. NON - FREIGHTED",
  "HBL EXPRESS RELEASE FREIGHTED",
  "HBL EXPRESS RELEASE NON - FREIGHTED",
  "CERTIFICATE OF ORIGIN",
  "COMMERCIAL INVOICE",
  "HAZARDOUS DECLARATION",
  "PACKING LIST",
  "MASTER B/L",
  "SHIPPER'S EXPORT DECLARATION",
];

export default function PrintDocumentsModal({ isOpen, onClose, onPrint }) {
  const documents = useMemo(
    () =>
      DOCUMENT_NAMES.map((name) => ({
        id: name.replace(/\s+/g, "_").toUpperCase(),
        name,
        remarks: "",
        highlightRow: name === "BOOKING RATE QUOTE",
      })),
    []
  );

  return (
    <PrintDocumentsSelectionModal
      isOpen={isOpen}
      onClose={onClose}
      documents={documents}
      onPrint={onPrint}
    />
  );
}
